import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { specraFocusRing } from './focus-ring';
const base = 'inline-flex shrink-0 items-center justify-center rounded-[var(--radius-xs)] bg-info-muted px-[var(--space-1)] text-[length:var(--fs-ui-label)] font-semibold leading-none tabular-nums text-info';
/** Rail-only. Never render inside document text; the document is an ONLYOFFICE iframe. */ export const SpecraCitationMarker = /*#__PURE__*/ React.forwardRef(({ className, index, label, onClick, type, ...props }, ref)=>{
    if (onClick) {
        return /*#__PURE__*/ _jsx("button", {
            "aria-label": label,
            className: cn(base, specraFocusRing, className),
            onClick: onClick,
            ref: ref,
            title: label,
            type: type ?? 'button',
            ...props,
            children: index
        });
    }
    return /*#__PURE__*/ _jsxs("span", {
        className: cn(base, className),
        ref: ref,
        title: label,
        ...props,
        children: [
            /*#__PURE__*/ _jsx("span", {
                "aria-hidden": "true",
                children: index
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                children: label
            })
        ]
    });
});
SpecraCitationMarker.displayName = 'SpecraCitationMarker';
